module.exports = __webpack_public_path__ + "img/pic3.76394552.png";